export const CLEAR_AUTHENTICATION = 'Clear the authentication'
export const LOGIN = 'Login to the system'
export const LOGOUT = 'Logout of the system'
